import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {TitleBar} from '../../../../design-system/organisms/TitleBar/TitleBar';
import {TitleBarType} from '../../../../design-system/organisms/TitleBar/TitleBarType.enum';
import {SchemeSection} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function Episode({section, children}: CommonSectionProps) {
  const {title} = section;
  const {ref, inView, entry} = useInView();
  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);
  const scheme =
    'scheme' in section ? (section as SchemeSection).scheme : undefined;
  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        viewimp_contents: {
          imp_id: 'sproduct',
          imp_provider: 'service',
          layer1: '회차',
        },
        click: {
          imp_id: 'sproduct',
          layer1: '회차',
          imp_provider: 'service',
        },
        customProps: {
          section_title: title,
          section_type: '회차',
        },
      })}
    >
      <TitleBar
        className="mb-4pxr"
        type={TitleBarType.Main}
        title={title || undefined}
        scheme={'scheme' in section ? scheme : undefined}
        onClickMore={e => LOG_CLICK_EVENT('더보기_클릭', e)}
        {...putTiaraObjectProps({
          eventMeta: {
            id: scheme,
            type: 'scheme',
            provider: '서비스',
          },
          customProps: {
            landing_path: scheme,
          },
        })}
      />
      {children}
    </div>
  );
}
